if (!customElements.get('gymstack-family-compare')) {
  class GymstackFamilyCompare extends HTMLElement {
    constructor() {
      super();
      this.fetchAttempts = 0;
      window.initLazyScript(this, this.init.bind(this), 500);
    }

    async init() {
      const payload = document.querySelector('product-family-picker script[data-family-data]');
      if (!payload) {
        this.remove();
        return;
      }

      let entries;
      try {
        entries = JSON.parse(payload.textContent);
      } catch (e) {
        entries = null;
      }

      if (!Array.isArray(entries) || entries.length < 2) {
        this.remove();
        return;
      }

      const maxItems = parseInt(this.dataset.maxItems, 10) || 4;
      const picked = GymstackFamilyCompare.pickRelevant(entries, maxItems);
      const ids = picked.map((entry) => entry.id).filter((id) => id);

      if (ids.length < 2) {
        this.remove();
        return;
      }

      const query = ids.map((id) => `id:${id}`).join(' OR ');

      try {
        const response = await fetch(`${this.dataset.url}&q=${encodeURIComponent(query)}`);
        if (!response.ok) throw new Error(response.status);

        const tmpl = document.createElement('template');
        tmpl.innerHTML = await response.text();

        const el = tmpl.content.querySelector('gymstack-family-compare');
        if (!el || !el.hasChildNodes()) {
          this.remove();
          return;
        }

        const ul = el.querySelector('ul[role="list"]');
        if (ul) {
          const items = ids.map((id) => {
            const card = el.querySelector(`product-card[data-product-id="${id}"]`);
            return card?.closest('li');
          }).filter(Boolean);

          ul.innerHTML = '';
          items.forEach((li) => ul.appendChild(li));
        }

        this.innerHTML = el.innerHTML;
        this.removeAttribute('hidden');
      } catch (error) {
        this.fetchAttempts += 1;

        if (this.fetchAttempts >= 3) {
          console.log(error);
          this.remove();
        } else {
          this.init();
        }
      }
    }

    /**
     * Orders siblings by relevance to the current product (current first,
     * then other sizes of the same flavour, then the same size in other
     * flavours, then the rest) and caps the list.
     */
    static pickRelevant(entries, maxItems) {
      const Picker = customElements.get('product-family-picker');
      const parse = Picker && typeof Picker.parseLabel === 'function'
        ? Picker.parseLabel.bind(Picker)
        : () => null;
      const norm = (v) => (v || '').toLowerCase().replace(/\s+/g, ' ').trim();

      const current = entries.find((e) => e.current);
      const currentParsed = current ? parse(current.label) : null;

      const rank = (entry) => {
        if (entry.current) return 0;
        if (!currentParsed) return 3;
        const parsed = parse(entry.label);
        if (!parsed) return 3;
        if (norm(parsed.flavor) === norm(currentParsed.flavor)) return 1;
        if (norm(parsed.size) === norm(currentParsed.size)) return 2;
        return 3;
      };

      return entries
        .map((entry, index) => ({ entry, index, rank: rank(entry) }))
        .sort((a, b) => a.rank - b.rank || a.index - b.index)
        .slice(0, Math.max(2, maxItems))
        .sort((a, b) => a.index - b.index)
        .map((item) => item.entry);
    }
  }

  customElements.define('gymstack-family-compare', GymstackFamilyCompare);
}
